import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 10.5L16.5 13.5M16.5 13.5L13.5 16.5M16.5 13.5H1.5M4.5 7.5L1.5 4.5M1.5 4.5L4.5 1.5M1.5 4.5H16.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSwitch;
